
export type ComposerPayloadContent = {
  /**
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
};
